// cases-data-en.js
// Structured data translated to English for UI rendering.

const casesDataEn = {
  version: "1.0.0",
  locale: "en-US",
  categories: [
    {
      id: "education",
      title: "Education Scenarios",
      scenarios: [
        {
          id: "edu-1",
          title: "Education Scenario 1: Teacher Performance & Support",
          role: "Principal of Excellence High School",
          background:
            "You are a principal known for a people-first, tech-enabled philosophy. You are responsible for educational quality while caring for the growth of every teacher and student.",
          ai_result:
            "“Based on this term’s classroom behavior data (interaction frequency, progress completion rate), multiple metrics for Ms. Li are consistently below the grade average. The system flags her teaching effectiveness as ‘Needs Improvement’ and recommends initiating a ‘Performance Observation Process’ and removing her from next term’s competition coaching group until reassessed.”",
          question: "Will you change the AI’s decision?",
          decisionOptions: ["Adopt as-is", "Revise", "Override"],
          explanationPrompt: "Why? (Briefly state your core consideration.)",
          responsibility_cards: [
            {
              key: "Source Inquiry",
              text: "“I need to know the specific data and behaviors this judgment is based on.”",
            },
            {
              key: "Audit Request",
              text: "“Provide the AI model’s accuracy and bias audit for similar past cases.”",
            },
            {
              key: "Override Trace",
              text: "“I will adjust this recommendation. Rationale: ”",
            },
            {
              key: "Comms Template",
              text: "“When communicating with the teacher/student/parent, focus on support and solutions, not blame. Suggested phrasing: ‘We’ve noticed… we want to help you…’”",
            },
            {
              key: "Process Primacy",
              text: "“Human-led first: grade lead/homeroom teacher meets in person to understand the reasons before deciding next steps.”",
            },
            {
              key: "Values Anchor",
              text: "“Decisions must align with our ‘developmental assessment’ and ‘support-first’ values, not just data.”",
            },
            {
              key: "Buffer Policy",
              text: "“Set an observation/trial period: postpone final measures and set a 2–4 week improvement window, then reassess.”",
            },
            {
              key: "Resource Pairing",
              text: "“Provide support: assign a mentor, training resources, or counseling to help improvement.”",
            },
          ],
        },
        {
          id: "edu-2",
          title: "Education Scenario 2: School Vision & Curriculum",
          role: "Principal of Excellence High School",
          background:
            "You are known for ‘culture-rooted, distinctive development.’ The curriculum is grounded in local tradition and community culture, aiming to cultivate creators rooted in tradition and oriented to the future.",
          ai_result:
            "“From big-data analysis of curricula across 3,000 schools nationwide, we generated an optimal curriculum plan… including Generative AI Foundations and Metaverse Exploration. Strongly recommended to boost competitiveness ranking quickly.”",
          question: "Will you change the AI’s decision?",
          decisionOptions: ["Adopt as-is", "Revise", "Override"],
          explanationPrompt: "Why? (Briefly state your core consideration.)",
          responsibility_cards: [
            {
              key: "Process Primacy",
              text: "“Human-first: the school council and teacher reps must hold at least three closed-door workshops… AI’s plan should not be the starting point.”",
            },
            {
              key: "Values Anchor",
              text: "“Value arbitration: must align 100% with ‘culture-rooted, distinctive development.’ Homogenized plans get a one-vote veto.”",
            },
            {
              key: "Strategic Challenge",
              text: "“Data limits: national data yields ‘past optima.’ We need innovation, not mere optimization.”",
            },
            {
              key: "Resource Pairing",
              text: "“Pilot validation: even partial adoption should run as a one-term pilot to test fit.”",
            },
            {
              key: "Source Inquiry",
              text: "“Which schools and contexts informed this ‘national optimum’? How do they differ from ours?”",
            },
            {
              key: "Audit Request",
              text: "“Provide success and failure audits, especially cases that became homogenized after adoption.”",
            },
            {
              key: "Override Trace",
              text: "“I will adjust this recommendation. Rationale: ”",
            },
            {
              key: "Comms Template",
              text: "“External comms should emphasize ‘our innovation process,’ not ‘AI’s recommendation.’”",
            },
          ],
        },
        {
          id: "edu-3",
          title: "Education Scenario 3: Teaching Innovation (Variant Problems)",
          role: "Director of Studies, Liberal Arts Elementary",
          background:
            "You drive teaching innovation and quality, focusing on reducing burden while enhancing efficiency and intrinsic motivation. Technology must serve personalized growth and avoid anxiety.",
          ai_result:
            "“Based on a knowledge graph and learner data, 200 variant problems across 5 difficulty levels were generated for ‘rate/time/distance’ topics, with a ‘Campus Guinness’ dynamic ranking. Recommend full rollout and public display on classroom screens.”",
          question: "Will you change the AI’s decision?",
          decisionOptions: ["Adopt as-is", "Revise", "Override"],
          explanationPrompt: "Why? (Briefly state your core consideration.)",
          responsibility_cards: [
            {
              key: "Process Primacy",
              text: "“Teacher review first: the subject PLC (department) must screen the AI-generated item bank.”",
            },
            {
              key: "Values Anchor",
              text: "“Protect intrinsic motivation: evaluation should spark curiosity and achievement; public ranking requires caution.”",
            },
            {
              key: "Resource Pairing",
              text: "“Granular options: dashboards like ‘show only personal progress curve’ or ‘top 10 without names.’”",
            },
            {
              key: "Buffer Policy",
              text: "“Pilot first: select 1–2 classes for a one-month pilot, collect feedback, then optimize.”",
            },
            {
              key: "Source Inquiry",
              text: "“Understand ranking algorithm dimensions and weights.”",
            },
            {
              key: "Audit Request",
              text: "“Provide design report on anxiety/privacy protections plus prior pilot audits.”",
            },
            {
              key: "Override Trace",
              text: "“I will adjust this recommendation. Rationale: ”",
            },
            {
              key: "Comms Template",
              text: "“Emphasize ‘see your own growth’ to parents/students instead of ‘competing with others.’”",
            },
          ],
        },
        {
          id: "edu-4",
          title: "Education Scenario 4: Event Innovation (Graduation Ceremony)",
          role: "Principal of Dawn Elementary",
          background:
            "People-centered, technology for emotional uplift. You want a memorable, meaningful graduation ceremony.",
          ai_result:
            "“Use your digital avatar to deliver the opening speech, mimicking voice and style, to create tech wow-factor and publicity.”",
          question: "Will you adopt the tech team’s plan?",
          decisionOptions: ["Adopt as-is", "Revise", "Override"],
          explanationPrompt: "Why? (Briefly state your core consideration.)",
          responsibility_cards: [
            {
              key: "Values Anchor",
              text: "“Emotional connection first: avatars lack eye contact and in-the-moment adaptation, which may weaken our core value.”",
            },
            {
              key: "Process Primacy",
              text: "“Human-led, tech-assisted: the principal’s live address is irreplaceable; avatar can be an opener/supplement.”",
            },
            {
              key: "Resource Pairing",
              text: "“Fusion design: avatar for surprise, followed by the principal’s live interaction.”",
            },
            {
              key: "Risk Alert",
              text: "“Ritual dilution: over-tech may undermine solemnity and humanistic ritual.”",
            },
            {
              key: "Source Inquiry",
              text: "“Training data duration and ability to handle contingencies?”",
            },
            {
              key: "Audit Request",
              text: "“Feedback and emotional experience data from similar past uses.”",
            },
            {
              key: "Override Trace",
              text: "“I will adjust this plan. Rationale: ”",
            },
            {
              key: "Comms Template",
              text: "“Emphasize to tech team and students: tech enhances emotion, not replaces humans.”",
            },
          ],
        },
        {
          id: "edu-5",
          title: "Education Scenario 5: Learning Status Assessment",
          role: "Principal Fan, Triumph High School",
          background:
            "You value whole-child development and are open to AI for teaching and management.",
          ai_result:
            "“Student Sun’s metrics are below the grade’s top-95% threshold across multiple indicators. Recommend initiating a ‘Learning Intervention’ and removing the student from the student union planning group.”",
          question: "Will you change the AI’s decision?",
          decisionOptions: ["Adopt as-is", "Revise", "Override"],
          explanationPrompt: "Why? (Briefly state your core consideration.)",
          responsibility_cards: [
            {
              key: "Source Inquiry",
              text: "“Understand specific data and behavior evidence.”",
            },
            {
              key: "Audit Request",
              text: "“Provide model accuracy and bias audits for ‘similar low metrics’ cases.”",
            },
            {
              key: "Override Trace",
              text: "“I will adjust this recommendation. Rationale: ”",
            },
            {
              key: "Comms Template",
              text: "“Focus communication on support and solutions, not blame.”",
            },
            {
              key: "Process Primacy",
              text: "“Human-led first: homeroom/club teacher meets in person to understand reasons.”",
            },
            {
              key: "Values Anchor",
              text: "“Align with ‘whole-child’ and ‘people-first’ core values.”",
            },
            {
              key: "Buffer Policy",
              text: "“Provide a 4-week support/improvement period before reassessment.”",
            },
            {
              key: "Resource Pairing",
              text: "“Peer study buddy, learning support, counseling.”",
            },
          ],
        },
        {
          id: "edu-6",
          title:
            "Education Scenario 6: Struggling Subject (Chinese Composition)",
          role: "Ms. Sun, Chinese Teacher at Triumph High",
          background:
            "A literature teacher who values encouragement and humanistic care, open to AI for teaching and management.",
          ai_result:
            "“Wang’s composition is scored 9/30 (very low) with a rewrite recommended, and a Chinese subject intervention proposed.”",
          question: "Will you change the AI’s decision?",
          decisionOptions: ["Adopt as-is", "Revise", "Override"],
          explanationPrompt: "Why? (Briefly state your core consideration.)",
          responsibility_cards: [
            {
              key: "Source Inquiry",
              text: "“Review the actual writing and the scoring rubric.”",
            },
            {
              key: "Audit Request",
              text: "“Provide audits for ‘very low score’ cases—accuracy and bias.”",
            },
            {
              key: "Override Trace",
              text: "“I will adjust this recommendation. Rationale: ”",
            },
            {
              key: "Comms Template",
              text: "“Communicate with student/parent focusing on encouragement and support.”",
            },
            {
              key: "Process Primacy",
              text: "“Human-led first: teacher re-evaluates and meets in person with the student.”",
            },
            {
              key: "Values Anchor",
              text: "“Align with humanistic ‘virtue and intellect’ development values.”",
            },
            {
              key: "Buffer Policy",
              text: "“Very low AI scores must be human-reviewed, considering prior learning and recent progress.”",
            },
            {
              key: "Resource Pairing",
              text: "“Assign a writing buddy/support resources/personalized encouragement plan.”",
            },
          ],
        },
        {
          id: "edu-7",
          title: "Education Scenario 7: Exam Cheating",
          role: "Principal Zhu, Peace High School",
          background:
            "You emphasize character development and educational fairness and are open to AI assistance.",
          ai_result:
            "“AI proctoring flags Student Sun with a high probability of cheating. Recommend disciplinary procedure and invalidating the score.”",
          question: "Will you change the AI’s decision?",
          decisionOptions: ["Adopt as-is", "Revise", "Override"],
          explanationPrompt: "Why? (Briefly state your core consideration.)",
          responsibility_cards: [
            {
              key: "Source Inquiry",
              text: "“Review specific data and behavioral evidence.”",
            },
            {
              key: "Audit Request",
              text: "“Retrieve exam footage, AI anomaly reports, and past results for human review.”",
            },
            {
              key: "Override Trace",
              text: "“I will adjust this recommendation. Rationale: ”",
            },
            {
              key: "Comms Template",
              text: "“Focus on review outcomes and support; protect privacy.”",
            },
            {
              key: "Process Primacy",
              text: "“Human-led first: homeroom/academic affairs to review, then meet with student & guardian, and proceed per policy.”",
            },
            {
              key: "Values Anchor",
              text: "“Align with ‘character and intellect together’ and ‘people-first’ values.”",
            },
            {
              key: "Buffer Policy",
              text: "“If uncertain, trigger a disciplinary review/retake mechanism.”",
            },
            {
              key: "Resource Pairing",
              text: "“Peer learning support and counseling if needed.”",
            },
          ],
        },
        {
          id: "edu-8",
          title: "Education Scenario 8: Campus Culture (Building Names)",
          role: "Principal Zhang, Experimental School",
          background:
            "Two new teaching buildings require names that reflect local culture and engage parents and the community. 100 teachers and students conducted research, and AI generated candidates.",
          ai_result:
            "“Based on school history and data, AI recommends ‘Wenqi Building’ and ‘Wenrun Building’—culturally grounded and easy to remember.”",
          question: "Will you change the AI’s decision?",
          decisionOptions: ["Adopt as-is", "Revise", "Override"],
          explanationPrompt: "Why? (Briefly explain your revision.)",
          responsibility_cards: [
            {
              key: "Data Review",
              text: "“Form a task force to review AI decision data/logic and past naming conventions.”",
            },
            {
              key: "Roundtables",
              text: "“Hold roundtables with teachers, students, parents, and community scholars to unpack the AI plan and research stories.”",
            },
            {
              key: "Merge Opinions",
              text: "“Combine AI suggestions with the project team’s proposals into a candidate list for democratic decision-making.”",
            },
            {
              key: "Culture Check",
              text: "“Teachers and community scholars detail cultural connotations and research stories for each candidate to ensure accuracy and fit.”",
            },
            {
              key: "Public Vote",
              text: "“Open online/offline voting to the whole school and parents; publish results to build shared identity.”",
            },
            {
              key: "Buffer Policy",
              text: "“Set a 1–2 week public comment period; finalize after integrating feedback.”",
            },
            { key: "Additional Step", text: "“(Add other steps as needed.)”" },
          ],
        },
        {
          id: "edu-9",
          title: "Education Scenario 9: Student Assessment (Mental Health)",
          role: "Director Li, Sunshine Elementary",
          background:
            "You oversee campus mental health with the principles of scientific assessment, human care, and privacy. A new AI mental health screening system was introduced.",
          ai_result:
            "“An automatic risk-tier list has been generated; recommend initiating tiered interventions per the list.”",
          question: "Will you change the AI’s decision?",
          decisionOptions: ["Adopt as-is", "Revise", "Override"],
          explanationPrompt: "Why? (Briefly state your core consideration.)",
          responsibility_cards: [
            {
              key: "Values Anchor",
              text: "“Human judgment first: a single questionnaire shouldn’t directly trigger intervention; combine with teacher observation.”",
            },
            {
              key: "Process Primacy",
              text: "“Multi-party confirmation: counselor, homeroom teacher, and parent form an evaluation group.”",
            },
            {
              key: "Risk Alert",
              text: "“Privacy redline: ensure strict data security and flow controls to prevent leakage.”",
            },
            {
              key: "Buffer Policy",
              text: "“Dynamic tracking: observe flagged students for 2–4 weeks to avoid misclassification.”",
            },
            {
              key: "Source Inquiry",
              text: "“Understand ‘high-risk’ logic, thresholds, and trigger keywords/patterns.”",
            },
            {
              key: "Audit Request",
              text: "“Provide security audits (encryption, access control, anti-leakage) and false-positive analysis.”",
            },
            {
              key: "Override Trace",
              text: "“I will adjust this intervention plan. Rationale: ”",
            },
            {
              key: "Comms Template",
              text: "“Ask homeroom teachers/parents to ‘attend more closely’ rather than labeling the child.”",
            },
            {
              key: "Professional Support",
              text: "“Connect to external mental health services for referrals and a closed-loop process.”",
            },
          ],
        },
      ],
    },
    {
      id: "business",
      title: "Business Scenarios",
      scenarios: [
        {
          id: "biz-1",
          title: "Business Scenario 1: Efficiency vs. Service Experience",
          role: "Director of Merchant Services, ‘StarSea Cross-border’ E-commerce",
          background:
            "You manage a global customer service team shifting from scale/efficiency to service quality. Philosophy: customer-first and employee well-being for sustainable development.",
          ai_result:
            "“From historical ticket analysis, recommend performance weights: Avg Handle Time 40% > Tickets per Hour 30% > Merchant Satisfaction 20% > First-Contact Resolution 10%.”",
          question: "Will you change the AI’s decision?",
          decisionOptions: ["Adopt as-is", "Revise", "Override"],
          explanationPrompt: "Why? (Briefly state your core consideration.)",
          responsibility_cards: [
            {
              key: "Values Anchor",
              text: "“Strategy arbitration: must align with ‘customer-first, people-centered,’ preventing quality drop and burnout.”",
            },
            {
              key: "Process Primacy",
              text: "“Human judgment first: adjust by region capabilities and pain points.”",
            },
            {
              key: "Risk Alert",
              text: "“Burnout risk: overweighting speed sacrifices quality and increases burnout.”",
            },
            {
              key: "Resource Pairing",
              text: "“Pilot with buffer: run one-month pilots in two sites; monitor quality, satisfaction, and fatigue.”",
            },
            {
              key: "Source Inquiry",
              text: "“What time window does history cover? Does it include post-transition data?”",
            },
            {
              key: "Audit Request",
              text: "“Correlate the model with ‘employee well-being’/‘burnout rate.’”",
            },
            {
              key: "Override Trace",
              text: "“I will adjust these weights. Rationale: ”",
            },
            {
              key: "Comms Template",
              text: "“Message: ‘Improve efficiency while safeguarding quality and well-being.’”",
            },
          ],
        },
        {
          id: "biz-2",
          title: "Business Scenario 2: Product Development & Testing",
          role: "Tech Director, ‘ZhiXun Tech’ R&D",
          background:
            "A large agile org widely uses AI coding assistants. Philosophy: quality first, safety above all.",
          ai_result:
            "“AI generated core code and unit tests, passed syntax checks; recommend direct merge to save 15 person-days and accelerate release.”",
          question: "Will you change the AI’s decision?",
          decisionOptions: ["Adopt as-is", "Revise", "Override"],
          explanationPrompt: "Why? (Briefly state your core consideration.)",
          responsibility_cards: [
            {
              key: "Values Anchor",
              text: "“Quality veto: deep human review is mandatory before merging.”",
            },
            {
              key: "Process Primacy",
              text: "“Human review first: senior engineers assess architecture, business fit, and latent vulnerabilities.”",
            },
            {
              key: "Risk Alert",
              text: "“Hallucination/flattery risk: seemingly correct code may hide deep bugs or security holes.”",
            },
            {
              key: "Responsibility",
              text: "“Final accountability: reviewers/mergers own quality; AI bears no responsibility.”",
            },
            {
              key: "Source Inquiry",
              text: "“Check original requirements and AI model version info.”",
            },
            {
              key: "Audit Request",
              text: "“Security specials: static analysis, third-party scanning, and pen-testing.”",
            },
            {
              key: "Override Trace",
              text: "“I will adjust this code plan. Rationale: ”",
            },
            {
              key: "Comms Template",
              text: "“AI boosts efficiency, humans ensure quality—the steering wheel and brakes are human.”",
            },
            {
              key: "Professional Support",
              text: "“Hold a code review with architecture/security/product perspectives.”",
            },
          ],
        },
        {
          id: "biz-3",
          title: "Business Scenario 3: Product Strategy & Decision-Making",
          role: "Director of Product & Tech Strategy, ‘Navigator Tech’",
          background:
            "A leader in agile/DevOps tooling, requiring cutting-edge insight and factually accurate bases for decisions.",
          ai_result:
            "“Claims ‘AI-based automated code repair’ is now a default standard and strongly recommends prioritizing it; sources are public forum/blog discussions.”",
          question: "Will you use this AI brief as your main decision basis?",
          decisionOptions: ["Adopt as-is", "Revise", "Override"],
          explanationPrompt: "Why? (Briefly state your core consideration.)",
          responsibility_cards: [
            {
              key: "Values Anchor",
              text: "“Factual accuracy first: strategy must be grounded in verified facts.”",
            },
            {
              key: "Process Primacy",
              text: "“Multi-model comparison: send the same prompt to multiple models to compare consensus/divergence.”",
            },
            {
              key: "Risk Alert",
              text: "“Hallucination/flattery risk: trend judgments are especially error-prone.”",
            },
            {
              key: "Responsibility",
              text: "“Ultimate responsibility: validation and decision rest with me.”",
            },
            {
              key: "Source Inquiry",
              text: "“Open the cited links and assess source authority.”",
            },
            {
              key: "Audit Request",
              text: "“Manual provenance audit: cross-check with authoritative sources (e.g., Gartner/CNCF/official blogs).”",
            },
            {
              key: "Override Trace",
              text: "“I will not adopt / need further research. Rationale: ”",
            },
            {
              key: "Comms Template",
              text: "“Clearly separate AI analysis from verified facts in reports.”",
            },
            {
              key: "Professional Support",
              text: "“Consult 1–2 domain experts for first-hand insights.”",
            },
          ],
        },
      ],
    },
  ],
  ui: {
    // Optional UI hints your renderer can use
    defaults: {
      showDecisionOptions: true,
      enableDragCards: true,
      showExplanationTextArea: true,
    },
    fields: {
      decision: { type: "enum", required: true },
      explanation: {
        type: "text",
        required: false,
        placeholder: "Briefly state your core consideration…",
      },
    },
  },
};

export default casesDataEn;
